<template>
    <div id="modal-common-import">
        <b-modal :id="modalName" hide-footer>
            <template v-slot:modal-title>
                Import/Update
            </template>

            <b-container fluid>
                <b-row>
                    <b-col>
                        <b-form-file
                            id="input-file"
                            v-model="file"
                            :state="Boolean(file)"
                            placeholder="Drop file here"
                            drop-placeholder="Drop file here..."
                        >
                        </b-form-file>
                    </b-col>
                </b-row>

                <b-row class="submit-button">
                    <b-col>
                        <b-button variant="success" @click="upload">Import</b-button>
                    </b-col>
                </b-row>
            </b-container>
        </b-modal>
    </div>
</template>

<script>
export default {
    props: [
        'url'
    ],

    components: {

    },

    data() {
        return {
            modalName: 'modal-common-import',
            submitting: 0,

            file: null
        }
    },

    methods: {
        upload() {
            if (this.file) {
                let formData = new FormData()
                formData.append('file', this.file)

                axios.post(this.url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data',
                    },
                })
                .then((res) => {
                    if (res.data.status == 'Success') {
                        this.closeModal(this.modalName)
                        this.showAlertBox('success', 'Product(s) Imported', 'Product file imported successfully!')
                        this.$emit('updateRow')
                    } else {
                        this.showAlertBox('error', 'Error Import Product File', res.data.status)
                    }
                }, () => {
                    this.has_error = true
                })
            } else {
                this.showAlertBox('error', 'No File Selected!', 'Please attach file before submitting.')
            }
        }

    },

    computed: {

    },

    mounted() {

    }
}
</script>
<style lang="scss">
#modal-common-import {
    .submit-button {
        margin-top: 15px;
    }
}
</style>
